import { isPrepackSurfaceLive } from './prepackSurfaceLive'

// `live` stands in for a surface the caller has already judged.
export function PrepackSurfaceLiveTag({ surface, live = isPrepackSurfaceLive(surface) }) {
  if (!live) return null
  return <span className="shrink-0 rounded bg-[var(--wf-color-success-soft)] px-1.5 py-0.5 text-[10px] font-semibold text-[var(--wf-color-success)]">Live</span>
}
